module.exports = __webpack_public_path__ + "img/bg.6b0f19eb.svg";